import { Route } from '@angular/router';

import {
  PageChangelogComponent,
  PageLoginComponent,
  PageOauth2LandingComponent,
  PagePwdResetComponent,
  PageResetRequestComponent,
} from '@infodata-group/inf-commons-desktop';
import { authorizationGuardFn } from '@infodata-group/inf-commons';

export const appRoutes: Route[] = [
  { path: 'login', component: PageLoginComponent },
  { path: 'oauth2', component: PageOauth2LandingComponent },
  { path: 'reset-request', component: PageResetRequestComponent },
  { path: 'reset-password', component: PagePwdResetComponent },
  { path: '', redirectTo: 'report', pathMatch: 'full' },
  {
    path: '',
    loadComponent: () =>
      import('./page/page-main/page-main.component').then(
        (m) => m.PageMainComponent,
      ),
    canActivate: [authorizationGuardFn],
    children: [
      {
        path: 'report',
        loadComponent: () =>
          import('./page/page-daily-report/page-daily-report.component').then(
            (m) => m.PageDailyReportComponent,
          ),
      },
      { path: 'changelogs', component: PageChangelogComponent },
    ],
  },
];
